export default "__VITE_ASSET__C0n1M_Q___"